import React, {useEffect, useState} from 'react'
import {ApiRequest} from '../../../../../../services/api/api'
import { Button, Form, Input, InputNumber, Modal, Switch } from 'antd'
import {commonFormSelect, getSelectOptions} from '../../../../../../components/common/common-form/common-form-select'
import CommonForm, {ItemElementPropsInterface} from '../../../../../../components/common/common-form/common-form'
import {urlKey} from '../../../../../../services/api/api-urls'
import { checkMachineUserName2 } from '../../suborder-list/suborder-modal/suborder-common-modal/suborder-common-modal'
import SweetAlertService from '../../../../../../services/lib/utils/sweet-alert-service'
import { getCookie } from 'react-use-cookie'

export const PackagingCompleteModal = (props: {visible: any, onOk: any, onCancel: any, data: any, machine: any, updateValueFn: any, isNotRequiredPassword?: boolean}) => {
  let isDataAvailable = false
  let defaultQty: any = null
  const [initFormValues, setInitFormValues] = useState<any>()
  const [formRef, setFormRef] = useState<any>()
  const [comment, setComment] = useState<any>('')
  const [boxOptions, setBoxOptions] = useState([])
  const [plateOptions, setPlateOptions] = useState([])
  const [postRequestBoxIdArrs, setPostRequestBoxIdArrs] = useState<any>([])
  const {visible, onOk, onCancel, data, machine} = props
  const [isVisible, setIsVisible] = useState(false)
  const [receivedQty, setReceivedQty] = useState<any>()
  const [loggedInUserId, setLoggedInUserId] = useState("")
  const [rawmaterialNotes, setRawmaterialNotes] = useState<any>('')
  const [suborderNotes, setSuborderNotes] = useState<any>('')


  useEffect(() => {
    if (!visible) {
      setIsVisible(false)
      return
    }
    if (props.isNotRequiredPassword && visible) {
      setIsVisible(true)
      return
    }
    if (!props.isNotRequiredPassword) {
      checkMachineUserName2(visible, machine, setIsVisible,setLoggedInUserId, onCancel)
    }
  }, [props.visible])

  useEffect(() => {
    console.log(data)
    if (data?.suborderId && !isDataAvailable) {
      // Fetch initial suborderNotes and rawmaterialNotes
      ApiRequest({
        url: 'Suborder/GetSuborderLog?suborderId=' + data.suborderId,
        method: 'get',
        isShowSpinner: true
      }).then(resLog => {
        const logData = resLog.data.data || []
        if (logData.length > 0) {
          const latestLog = logData[0]
          setSuborderNotes(latestLog.comment || '')
          setRawmaterialNotes(latestLog.rawmaterialNotes || '')
        }
      }).catch(err => {
        console.error('Error fetching suborder log:', err)
      })

      ApiRequest({
        url: 'PlateBox/GetAllPlateBox?suborderId=' + data.suborderId,
        method: 'get',
        isShowSpinner: true
      }).then(resPlateBox => {
        const plateBoxData = resPlateBox.data.data || []
        console.log(plateBoxData)
        getSelectOptions('', 'Box/GetAllBox?suborderId=' + data.suborderId).then(res => {
          res.sort((a: any, b: any) => a.sequence - b.sequence)
          const formValues: any = []
          const postBoxIds: any = []
          res.map((row: any) => {
            const filteredValue = plateBoxData.filter((plateBoxItem: any) => plateBoxItem.boxId === row.boxId)[0]
            console.log(defaultQty)
            formValues.push({
              boxId: row.boxId,
              barCode: row.barCode,
              quantity: filteredValue?.plateId ? filteredValue?.box?.quantity : defaultQty,
              plateId: filteredValue?.plateId || null
            })
            if (filteredValue && !filteredValue.plateId) {
              postBoxIds.push(row.boxId)
            }
          })
          console.log(postBoxIds)
          console.log(formValues)
          setPostRequestBoxIdArrs(postBoxIds)
          setInitFormValues({
            plateBox: formValues
          })
          setBoxOptions(res)
        }).catch(() => {
          // 错误已由 axios interceptor 处理，这里静默处理避免未处理的 Promise rejection
        })
      }).catch(() => {
        // 错误已由 axios interceptor 处理，这里静默处理避免未处理的 Promise rejection
      })
      isDataAvailable = true
      ApiRequest({
        url: 'PackagingType/GetPackagingTypeById?id=' + data.workOrder?.product?.baseProduct?.packagingTypeId,
        method: 'get',
        isShowSpinner: true
      }).then(resType => {
        defaultQty = resType.data.data.quantity
        console.log(defaultQty)
      }).catch(() => {
        // 错误已由 axios interceptor 处理，这里静默处理避免未处理的 Promise rejection
      })
      ApiRequest({
        url: 'Plate/GetAvailablePlate?package=1',
        method: 'get',
        isShowSpinner: true
      }).then(resPlate => {
        const palletOptions = resPlate.data.data
        ApiRequest({
          url: 'Plate/GetPalletBySuborder?suborderid=' + data.suborderId,
          method: 'get',
          isShowSpinner: true
        }).then(resPlate => {
          const palletOptions2 = resPlate.data.data
          palletOptions2.map((e: any) => {
            e.plateCode = e.plateCode + ' in Warehouse已经在仓库'
            palletOptions.push(e)
          })
          setPlateOptions(palletOptions)
        }).catch(() => {
          // 错误已由 axios interceptor 处理，这里静默处理避免未处理的 Promise rejection
        })
      }).catch(() => {
        // 错误已由 axios interceptor 处理，这里静默处理避免未处理的 Promise rejection
      })
      console.log(data)
    }
  }, [data])

  const onforceSubmit = async () => {
    const result = await SweetAlertService.confirmMessage()
    if (!result) return;
    if (!formRef) {
      onCancel()
      return
    }
    formRef.submit()
      ApiRequest({
        url: 'Suborder/FinishSuborder?id='+data.suborderId,
        method: 'put',
        data: {
          comment:comment,
          quantity:receivedQty??0,
          machineId: machine.machineId
        }
      }).then(_ => {
        onOk()
      }).catch(() => {
        // 错误已由 axios interceptor 处理，这里静默处理避免未处理的 Promise rejection
      })
  }
  const onSubmit = async () => {
    if (!formRef) {
      onCancel()
      return
    }
    let postRequestData: any = []
    let putRequestData: any = []
    const deleteRequestDataIds: any = []
    formRef.submit()
    const formValues = await formRef.validateFields()
    if (formValues) {
      const plateBox = formValues.plateBox || []
      plateBox.map((row: any) => {
        if (row.isDelete) {
          deleteRequestDataIds.push(row.boxId)
        } else {
          if (postRequestBoxIdArrs.includes(row.boxId)) {
            postRequestData.push(row)
          } else {
            putRequestData.push(row)
          }
        }
      })
      postRequestData = postRequestData.filter((row: any) => row.plateId)
      putRequestData = putRequestData.filter((row: any) => row.plateId)
      console.log(postRequestData)
      console.log(putRequestData)
      console.log(deleteRequestDataIds)
      const loggedInUserIdRef = Number(getCookie('suborder_operator_id', loggedInUserId));
      if (!postRequestData.length && !putRequestData.length && !deleteRequestDataIds.length) {
        SweetAlertService.errorMessage('请先添加箱子/Please add boxes firstly.')
        return
      }
      ApiRequest({
        url: 'PlateBox/AddAndUpdatePlateBoxAndBoxQuantity',
        method: 'put',
        data: {
          addList: postRequestData,
          updateList: putRequestData,
          deleteBoxIdList: deleteRequestDataIds
        }
      }).then(_ => {
        setReceivedQty(null)
        props.updateValueFn({
          comment: suborderNotes
        }).then((res: any) => {
          if (res !== 'err') {
            ApiRequest({
              url: 'PlateBox/AddAndUpdateListAndComplete',
              method: 'put',
              data: {
                addAndUpdatePlateBox: {
                  addList: postRequestData,
                  updateList: putRequestData,
                  deleteBoxIdList: deleteRequestDataIds
                },
                suborderId: data.suborderId,
                suborderLog: {
                  ...res,
                  operEmployeeId: loggedInUserIdRef,
                  machineId: machine.machineId,
                  comment: suborderNotes, // 使用用户新输入的备注，而不是从API获取的旧备注
                  rawmaterialNotes: rawmaterialNotes
                }
              }
            }).then(_ => {
              onOk()
            }).catch(() => {
              // 错误已由 axios interceptor 处理，这里静默处理避免未处理的 Promise rejection
            })
          }
        }).catch(() => {
          // 错误已由 axios interceptor 处理，这里静默处理避免未处理的 Promise rejection
        })
      }).catch(() => {
        // 错误已由 axios interceptor 处理，这里静默处理避免未处理的 Promise rejection
      })
    }
  }

  const formItems: ItemElementPropsInterface[] | any = [
    [
      {name: ['plateBox', 'boxId'], isNotEditable: true, label: '箱子条形码/Box Barcode', inputElement: commonFormSelect(urlKey.Box, boxOptions, ['barCode'], false)},
      {name: ['plateBox', 'quantity'], label: '数量/Quantity', rules: [{type: 'number', min: 0}], inputElement: <InputNumber />},
      {name: ['plateBox', 'plateId'], isNotEditable: true, label: '托盘/Pallet', inputElement: commonFormSelect(urlKey.Plate, plateOptions, ['plateCode'], true)},
      {name: ['poDetail', 'isDelete'], label: '删除/Delete', inputElement: <Switch />, otherProps: {valuePropName: 'checked'}},
    ]
  ]

  const onFormChange = (changedValues: any, newValues: any, form: any) => null

  const onFormBlur = (form: any) => {
    setFormRef(form)
  }

  const onReceivedQtyConfirm = () => {
    if (!receivedQty) {
      SweetAlertService.errorMessage('Received Qty Required.')
      return
    }
    const fieldsValue = formRef.getFieldsValue().plateBox
    const defaQty = fieldsValue[0].quantity
    console.log(fieldsValue)
    console.log(receivedQty)
    let remainQty: any = receivedQty
    const newFieldsValue = fieldsValue.map((row: any) => {
      if (remainQty < defaQty) {
        if (remainQty > 0) {
          const returnData = {
            ...row,
            quantity: remainQty
          }
          remainQty -= defaQty
          return returnData
        }
        return {
          ...row,
          quantity: 0
        }
      } else {
        remainQty -= defaQty
        return row
      }
    })
    console.log(newFieldsValue)
    formRef.setFieldsValue({
      plateBox: newFieldsValue
    })
  }

  const commentsForm = (
    <div>
      <div style={{marginBottom: '16px'}}>
        <div style={{marginBottom: '8px'}}>备注/Notes:</div>
        <Input.TextArea
          value={suborderNotes}
          onChange={(e: any) => setSuborderNotes(e.target.value)}
          placeholder="请输入备注/Please enter notes"
          rows={3}
        />
      </div>
      <div style={{marginBottom: '16px'}}>
        <div style={{marginBottom: '8px'}}>原材料备注/Raw Material Notes:</div>
        <Input.TextArea
          value={rawmaterialNotes}
          onChange={(e: any) => setRawmaterialNotes(e.target.value)}
          placeholder="请输入原材料备注/Please enter raw material notes"
          rows={3}
        />
      </div>
    </div>
  )

  return (
    <Modal destroyOnClose={true} title="打包完成/Packaging Complete" visible={isVisible} onCancel={onCancel} width={1000}
      footer={false}
    >
      <div style={{display: 'flex', justifyContent: 'flex-end', marginTop: '1rem'}}>
        <Button
          onClick={onCancel}
          style={{marginRight: '2rem'}}
        >取消/Cancel</Button>
        <Button
          onClick={onSubmit}
          type="primary"
        >提交/Submit</Button>
      </div>
      <div style={{margin: '1rem 0'}}>
        实际收到数量/Actual Qty: <InputNumber value={receivedQty} onChange={(value) => setReceivedQty(value)} />
        <Button
          type="primary"
          ghost
          onClick={onReceivedQtyConfirm}
          style={{marginLeft: '2rem'}}
        >确认/Confirm</Button>
      </div>
      <CommonForm items={formItems} onFormChange={onFormChange} onFormBlur={onFormBlur} initFormValues={initFormValues} />
      <div style={{margin: '1rem 0'}}>
        {commentsForm}
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '1rem' }}>
      <Button
        onClick={onforceSubmit}
        style={{ marginRight: '2rem' }}
      >强制提交/Force Commit</Button>
      <div style={{ display: 'flex' }}>
        <Button
          onClick={onCancel}
          style={{ marginRight: '2rem' }}
        >取消/Cancel</Button>
        <Button
          onClick={onSubmit}
          type="primary"
        >提交/Submit</Button>
      </div>
    </div>      
    </Modal>
  )
}